module.exports = __webpack_public_path__ + "img/icon-share.3ef82dff.png";